// Itens jogáveis de uma edição/torneio (`GET jogo/edicoes/:id`). O back manda
// `itens` (passatempos + jogos, já ordenados); edições antigas só têm `passatempos`.
import { gameRoute } from '../../games/core/routing/gameRoute';

interface RawItem {
  kind?: string;
  id: number;
  tipoId?: number | null;
  titulo?: string | null;
  subtitulo?: string | null;
}

interface RawPassatempo {
  id: number;
  titulo?: string | null;
  texto?: string | null;
  subtitulo?: string | null;
  disponivel?: boolean;
  tiposDePassatemposId?: number | null;
}

export interface TournamentDetail {
  nome?: string | null;
  foto?: string | null;
  itens?: RawItem[] | null;
  passatempos?: RawPassatempo[] | null;
}

export interface TournamentItem {
  key: string;
  id: number;
  tipoId: number | null;
  titulo: string;
  subtitulo: string;
  disponivel: boolean;
  route: string | null;
}

export function tournamentItems(detail: TournamentDetail | null | undefined): TournamentItem[] {
  if (!detail) return [];
  if (Array.isArray(detail.itens)) {
    return detail.itens.map((item) => {
      const tipoId = item.tipoId ?? null;
      return {
        key: `${item.kind ?? 'item'}-${item.id}`,
        id: item.id,
        tipoId,
        titulo: item.titulo ?? '',
        subtitulo: item.subtitulo ?? '',
        disponivel: true,
        // jogo sem tipo: o id é do espaço de jogos, não de passatempo (cruzada) -> sem rota
        route: item.kind === 'jogo' && tipoId === null ? null : gameRoute(tipoId, item.id),
      };
    });
  }
  const passatempos = Array.isArray(detail.passatempos) ? detail.passatempos : [];
  return passatempos.map((p) => {
    const tipoId = p.tiposDePassatemposId ?? null;
    return {
      key: `passatempo-${p.id}`,
      id: p.id,
      tipoId,
      titulo: p.titulo ?? '',
      subtitulo: p.texto ?? p.subtitulo ?? '',
      disponivel: p.disponivel !== false,
      route: gameRoute(tipoId, p.id),
    };
  });
}
